import React from 'react';
import './Footer.css';
import { HashLink } from 'react-router-hash-link';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-col">
            <h4>Notary Public Express Service</h4>
            <p>"Your trusted partner for all notary needs"</p>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><HashLink to="/#home" smooth>Home</HashLink></li>
              <li><HashLink to="/#services" smooth>Services</HashLink></li>
              <li><HashLink to="/#about" smooth>About</HashLink></li>
              <li><HashLink to="/#contact" smooth>Contact</HashLink></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <p><a href="tel:+14374490147">(437) 449-0147</a></p>
            <p><a href="mailto:info@notarypublicexpress.ca">info@notarypublicexpress.ca</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Notary Public Express Service. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;